import {
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { grey } from "@mui/material/colors";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import { GetAIModelHelper, GetAIProvidersHelper } from "../helper/ApiKeyHelper";
import LoopIcon from "@mui/icons-material/Loop";
import {
  AddAIConfigAction,
  TestModelAction,
  UpdateAIConfigAction,
} from "../../../../../store/Ancillary/AIConfig/Action";
import { toast } from "react-toastify";

const ApiConfigPopup = ({ editedRecord, setOpenPopup }) => {
  const dispatch = useDispatch();
  const [aiConfig, setAiConfig] = useState({
    ai_token: "",
    ai_provider: "",
    model_selected: "",
  });
  const [searchRefreshKey, setSearchRefreshKey] = useState(0)
  const isDisable = editedRecord ? true : false;
  const [errors, setErrors] = useState({});

  const [isLoadingbtn, setIsLoadingbtn] = useState(false);
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [fetchModel, setFetchedModel] = useState([]);

  const [modelType, setModelType] = useState({
    load: true,
    values: [],
  });

  useEffect(() => {
    if (aiConfig?.ai_provider && aiConfig?.ai_token) {
      GetAIModelHelper({ apiKey: aiConfig?.ai_token || "", provider: aiConfig?.ai_provider }).then((res) => {
        if (res?.data?.statuscode === 200) {
          const rawModels = res?.data?.data || [];
          const processed = rawModels.map((item) => ({
            ...item,
            display_name: (item.display_name || item.name || "").replace(/^models\//, ""),
          }));
          setFetchedModel(processed);
        } else {
          setFetchedModel([]);
        }
      });
    } else {
      setFetchedModel([]);
    }
  }, [aiConfig?.ai_provider, aiConfig?.ai_token]);

  useEffect(() => {
    setModelType({ load: false, values: fetchModel || [] });
  }, [fetchModel]);

  const validate = (fieldValues) => {
    let temp = { ...errors };
    if ("ai_token" in fieldValues) {
      temp.ai_token = fieldValues.ai_token ? "" : "API key is required";
    }
    if ("ai_provider" in fieldValues) {
      temp.ai_provider = fieldValues.ai_provider
        ? ""
        : "AI provider is required";
    }
    if (aiConfig?.ai_provider && aiConfig?.ai_token) {
      if ("model_selected" in fieldValues) {
        temp.model_selected = fieldValues.model_selected
          ? ""
          : "Model is required";
      }
    }
    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };
  const handleInputChange = (event, value) => {
    if (["model_selected"].includes(event)) {
      setAiConfig({ ...aiConfig, [event]: value || "" });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...aiConfig, [event]: value });
    } else {
      setAiConfig({
        ...aiConfig,
        [event.target.name]: event.target.value,
      });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...aiConfig, [event.target.name]: event.target.value });
    }
  };

  const handleSubmit = (event) => {
    if (validate(aiConfig)) {
      setIsSaveLoading(true);
      dispatch(
        TestModelAction(
          {
            apiKey: aiConfig?.ai_token,
            model: aiConfig?.model_selected?.name,
            provider: aiConfig?.ai_provider,
            setting: true,
          },
          (error, result) => {
            setIsSaveLoading(false);
            if (!error && result?.data?.statuscode === 200) {
              if (editedRecord?.ai_token_configuration_pk) {
                dispatch(
                  UpdateAIConfigAction({
                    ...aiConfig,
                    ai_type: aiConfig?.ai_provider,
                    ai_token_json: aiConfig?.model_selected
                      ? JSON.stringify(aiConfig?.model_selected)
                      : "",
                    ai_token_configuration_fk: editedRecord?.ai_token_configuration_pk || aiConfig?.ai_token_configuration_pk,
                  })
                );
              } else {
                dispatch(
                  AddAIConfigAction({
                    ...aiConfig,
                    ai_type: aiConfig?.ai_provider,
                    ai_token_json: aiConfig?.model_selected
                      ? JSON.stringify(aiConfig?.model_selected)
                      : "",
                  })
                );
              }
              setOpenPopup(false);
            } else {
              // Keep selected provider, API key, and model displayed in state on failure
            }
          }
        )
      );
    }
  };
  useEffect(() => {
    if (editedRecord) {
      let parsedModel = editedRecord?.ai_token_json;
      if (typeof parsedModel === "string") {
        try {
          parsedModel = JSON.parse(parsedModel);
        } catch (e) {}
      }
      if (parsedModel && typeof parsedModel === "object") {
        parsedModel = {
          ...parsedModel,
          display_name: (parsedModel.display_name || parsedModel.name || "").replace(/^models\//, "")
        };
      }
      setAiConfig({
        ...editedRecord,
        ai_provider: editedRecord?.ai_type,
        model_selected: parsedModel,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editedRecord]);

  const fetchAIModel = () => {
    setIsLoadingbtn(true);
    GetAIModelHelper({ apiKey: aiConfig?.ai_token || "", provider: aiConfig?.ai_provider, showToast: true }).then((res) => {
      if (res?.data?.statuscode === 200) {
        const rawModels = res?.data?.data || [];
        const processed = rawModels.map((item) => ({
          ...item,
          display_name: (item.display_name || item.name || "").replace(/^models\//, ""),
        }));
        setFetchedModel(processed);
        if (res?.data?.data?.length > 0) {
          toast.dismiss();
          toast.info(<>
            Models Loaded <br />
            Found {res?.data?.data?.length} available models.
          </>);
        }
      }
      setIsLoadingbtn(false);
    });
  };
  const [aiProviders, setAiProviders] = useState([]);

  useEffect(() => {
    GetAIProvidersHelper().then(res => {
      if (res?.data?.statuscode === 200) {
        setAiProviders(res?.data?.data || []);
      }
    });
  }, []);

  const handleModel = () => {
    setModelType({ load: false, values: fetchModel || [] });
  };
  return (
    <Grid container>
      <Grid container rowSpacing={2.5} px={2}>
        <Grid item xs={12} md={12}>
          <FormControl fullWidth size="small" error={!!errors?.ai_provider}>
            <InputLabel id="ai-provider-label">AI Provider</InputLabel>
            <Select
              labelId="ai-provider-label"
              name="ai_provider"
              value={aiConfig?.ai_provider || ""}
              label="AI Provider"
              onChange={handleInputChange}
              disabled={isDisable}
            >
              {aiProviders.map((provider) => (
                <MenuItem key={provider.name} value={provider.name}>
                  {provider.display_name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{errors?.ai_provider}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={12}>
          <FormControl fullWidth>
            <TextField
              type="password"
              label="API Key"
              fullWidth
              name="ai_token"
              onChange={handleInputChange}
              value={aiConfig?.ai_token || ""}
              size="small"
              {...(errors.ai_token && {
                error: true,
                helperText: errors.ai_token,
              })}
            />
          </FormControl>
        </Grid>
        {/* Commented out Fetch Available Models button per requirement */}
        {/* 
        <Grid item xs={12} md={12}>
          <FormControl fullWidth>
            <Button
              variant="outlined"
              className="mpl-secondary-btn"
              onClick={fetchAIModel}
              startIcon={
                isLoadingbtn ? (
                  <CircularProgress size={18} color="inherit" />
                ) : (
                  <LoopIcon size={18} color="inherit" />
                )
              }
            >
              Fetch Available Models
            </Button>
          </FormControl>
        </Grid>
        */}
        <Grid item xs={12} md={12}>
          <FormControl fullWidth>
            <SelectableSearch
              isOptionEqualToValue={(option, value) =>
                  option.name ===
                  value.name
                }
              key={searchRefreshKey}
              label="Select Model"
              noOptionText="Select provider to load models"
              value={aiConfig?.model_selected || ""}
              loading={handleModel}
              fieldLabel="display_name"
              required={true}
              variant={"outlined"}
              name="model_selected"
              size="small"
              onChangeEvent={handleInputChange}
              data={modelType}
              {...(errors.model_selected && {
                error: true,
                helperText: errors.model_selected,
              })}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mt: 2,
        }}
      >
        <Button
          sx={{
            marginTop: "1rem",
            marginRight: "1rem",
            ":hover": { color: grey[50] },
          }}
          variant="outlined"
          className="mpl-secondary-btn"
          onClick={() => setOpenPopup(false)}
        >
          cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          disabled={isSaveLoading}
          className="mpl-primary-btn"
          sx={{ marginTop: "1rem", marginRight: "1rem" }}
          onClick={(e) => handleSubmit(e)}
          startIcon={
            isSaveLoading ? <CircularProgress size={18} color="inherit" /> : null
          }
        >
          {isSaveLoading ? "Testing..." : (editedRecord ? "Update" : "Save")}
        </Button>
      </Grid>
    </Grid>
  );
};

export default ApiConfigPopup;
